import { render, staticRenderFns } from "./loginDialog.vue?vue&type=template&id=55b48f3e&scoped=true&"
import script from "./loginDialog.vue?vue&type=script&lang=js&"
export * from "./loginDialog.vue?vue&type=script&lang=js&"
import style0 from "./loginDialog.vue?vue&type=style&index=0&id=55b48f3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b48f3e",
  null
  
)

export default component.exports